module.exports = __webpack_public_path__ + "img/plus-icon.6b2ff3b5.svg";